export default "__VITE_ASSET__DPIclq8P__"